import { createSlice } from "@reduxjs/toolkit";
import { getUserInstance, getConnectedInstance } from "../services/instance";

export interface AppConfig {
  isRecordingControlsEnabled?: boolean;
  isStopRecordingFeatureImplementedInAWS?: boolean;
  isOutboundPhoneEnabled?: boolean;
  outboundPhones?: Array<{ value: string; description: string }>;
  languages?: unknown;
  language?: unknown;
  voice?: unknown;
  business?: unknown;
  closureTabs?: unknown;
  managerNav?: unknown;
  resourcesByLob?: boolean;
  senderNumber?: string;
  transcriptsBucketName?: string;
  [key: string]: unknown;
}

export interface ConnectedInstance {
  instanceId: string;
  instanceUrl: string;
  arn: string;
  friendlyName: string;
  instanceAlias?: string;
  callsWaitingWarningThreshold?: number;
  callsWaitingErrorThreshold?: number;
  appConfig?: AppConfig;
  [key: string]: unknown;
}

export interface InstanceRecord {
  instanceId: string;
  instanceUrl: string;
  arn: string;
  friendlyName: string;
  [key: string]: unknown;
}

interface InstanceState {
  status: string;
  instances: InstanceRecord[];
  connectedInstance: ConnectedInstance | null;
  showModal: boolean;
  callsWaitingWarningThreshold?: number;
  callsWaitingErrorThreshold?: number;
}

const initialState: InstanceState = {
  status: "idle",
  instances: [],
  connectedInstance: null,
  showModal: false,
  callsWaitingWarningThreshold: undefined,
  callsWaitingErrorThreshold: undefined,
};

const instanceSlice = createSlice({
  name: "userInstance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserInstance.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getUserInstance.fulfilled, (state, action) => {
        const payload = action.payload as
          | { data?: { instances?: InstanceRecord[] } }
          | undefined;
        const instances = payload?.data?.instances ?? [];
        state.status = "success";
        state.instances = instances;
        state.showModal = instances && instances.length > 1 ? true : false;
        state.connectedInstance =
          instances && instances.length === 1
            ? (instances[0] as ConnectedInstance)
            : null;
      })
      .addCase(getUserInstance.rejected, (state) => {
        state.status = "rejected";
        state.instances = [];
        state.showModal = false;
      })
      .addCase(getConnectedInstance, (state, action) => {
        state.connectedInstance =
          action.payload as unknown as ConnectedInstance;
        state.showModal = false;
      });
  },
});

export default instanceSlice.reducer;
